
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Language Translator
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification & Experience: </h3>
              <p> <span class="step_no">1</span>Educational Background <br> -A bachelor's degree, Diploma in Engineering in a relevant field such as linguistics, translation, literature, or a specific area related to the industry of focus (e.g., engineering and technical). </p>
              <p> <span class="step_no">2</span>Language Proficiency <br> -proficiency in the source language (English) <br> -Proficiency in the target language (the language into which the text is being translated) <br> - Strong command of grammar, vocabulary, syntax, and cultural nuances in both languages. </p>
              <p> <span class="step_no">3</span>Experience <br> -having relevant translation experience for minimum one year, internships, or volunteer work can be beneficial. </p>
              <p> <span class="step_no">4</span>Technical Skills <br> -Familiarity with computer tools and software. <br> - Proficiency in using word processing software.</p>
              <p> <span class="step_no">5</span>Communication Skills <br> - Strong written and verbal communication skills to effectively convey the meaning and shades of the original text. </p>
              <p> <span class="step_no">6</span>Research Skills <br> - Ability to conduct research to ensure accurate and contextually appropriate translations, especially for specialized or technical content. </p>
              <p> <span class="step_no">7</span>Attention to Detail <br> - Strong attention to detail, as accuracy is crucial in translation. </p>
              <p> <span class="step_no">8</span>Professionalism <br> - Adherence to ethical standards, including confidentiality and maintaining a high level of professionalism in dealing with subject experts and stakeholders. </p>

            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>

        <p> <span class="step_no">1</span>3 years of relevant work experience in Govt. Sector. </p>
        <p> <span class="step_no">2</span>Proficient in handling computer and office related tools. </p>
        <p> <span class="step_no">3</span>Fluency in written and spoken. English including the ability to
            convey ideas. </p>


       </div>
    </div>
  </div> -->
  <!-- feature box close -->



  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs. 35,000/- to Rs. 45,000/- per month consolidated pay from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 3th April 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
        <p><span class="step_no">1</span>Strong analytical and documentation skills </p>
        <p><span class="step_no">2</span>Sound knowledge of MS-Office </p>
        <p><span class="step_no">3</span>Willingness and ability to travel extensively </p>
		<p><span class="step_no">4</span> Should be able to operate in unstructured environment with minimal support. </p>


      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>key job role:</h3>
            <p><span class="step_no">1</span>Translation:  The primary responsibility is to translate written documents, texts, or spoken words from English language to Indian regional languages vice versa. This may involve translating a variety of content such as texts book, technical manuals, and more. </p>
            <p><span class="step_no">2</span>Cultural Understanding:  A good translator needs to have a deep understanding of the cultural nuances associated with both the source and target languages. Cultural sensitivity is crucial to accurately convey the intended meaning of the message </p>
            <p><span class="step_no">3</span>Language Proficiency:  The translator must be highly proficient in both the source and target languages. This includes a strong command of grammar, vocabulary, syntax, and idiomatic expressions. </p>
            <p><span class="step_no">4</span>Research: Translators often need to conduct research to ensure accurate and contextually appropriate translations, especially when dealing with specialized or technical content.</p>
            <p><span class="step_no">5</span>Communication Skills: Strong communication skills are essential, as the translator may need to interact with subject experts or other stakeholders to clarify doubts or discuss specific requirements.</p>
            <p><span class="step_no">6</span>Specialization: Some translators specialize in specific fields such technical, literary, or audio translation. Specialization enhances expertise in a particular domain and ensures accurate translation of industry-specific terminology.</p>
            <p><span class="step_no">7</span>Proofreading and Editing:  After translating a document, a translator may be required to proofread and edit their work to ensure accuracy, coherence, and consistency.</p>
            <p><span class="step_no">8</span>Meeting Deadlines: Translators often work under tight deadlines, especially in NIMIs where timely delivery is crucial. Meeting deadlines while maintaining quality is a key aspect of the job.</p>
            <p><span class="step_no">9</span>Technology Skills:  Familiarity with computers, MS-Word, Adobe Software, translation tools and software can be beneficial for managing large volumes of text and ensuring consistency in terminology.</p>
            <p><span class="step_no">10</span>Confidentiality: Translators may deal with sensitive information, so maintaining confidentiality and adhering to ethical standards is essential.</p>
            <p><span class="step_no">11</span>Reading, Writing and text Typing knowledge in the regional language is essential</p>
          </div>
        </div>
      </div>
      <!-- feature box close -->

          <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p><span class="step_no">1</span>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year.</p>

            <p><span class="step_no">2</span> The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of  NIMI shall be final in this regard. </p>

            <p><span class="step_no">3</span> The decision of  NIMI shall be final in this regard. </p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->


    <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>No of Job opening:</h3> -<h2>12</h2> 
        <p><span class="step_no">1</span>Hindi - 01</p>
		<p><span class="step_no">2</span>Tamil - 01</p>
        <p><span class="step_no">3</span>Kannada - 01</p>
		<p><span class="step_no">4</span>Malayalam - 01</p>
        <p><span class="step_no">5</span>Telugu - 01</p>
		<p><span class="step_no">6</span>Marathi - 01</p>
        <p><span class="step_no">7</span>Gujarathi - 01</p>
		<p><span class="step_no">8</span>Odia - 01</p>
        <p><span class="step_no">9</span>Bengali - 01</p>
		<p><span class="step_no">10</span>Assame - 01</p>
        <p><span class="step_no">11</span>Urdu – 01</p>
		<p><span class="step_no">12</span>Punjabi – 01</p>


      </div>
    </div>
  </div> 
  <!-- feature box close -->
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p><span class="step_no">1</span>NIMI-Chennai-Tamilnadu</p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee. </p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
        <p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

     <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority.</p>

      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>



      </div>
    </div>
  </div> -->
  <!-- feature box close -->

   <!-- feature box begin -->
  <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card </p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates </p>



      </div>
    </div>
  </div> -->
  <!-- feature box close -->


<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
